import { useEffect, useState } from "react";

// Each entry maps to a :root[data-theme="..."] block in index.css. `dot` is only the swatch colour;
// the actual palette lives in CSS so a theme change is one attribute flip, not a re-render of styles.
const THEMES = [
  { id: "green", label: "Green", dot: "#16a34a" },
  { id: "blue", label: "Blue", dot: "#2563eb" },
  { id: "violet", label: "Violet", dot: "#7c3aed" },
];

const KEY = "fv-theme";

export default function ThemePicker() {
  // A previously-saved theme that has since been retired (teal/amber/rose) would otherwise set a
  // data-theme with no matching CSS block, leaving the UI on the default palette but the picker
  // showing nothing selected. Fall back to the default instead.
  const [theme, setTheme] = useState(() => {
    const saved = localStorage.getItem(KEY);
    return THEMES.some((t) => t.id === saved) ? saved : "blue";
  });

  useEffect(() => {
    // "blue" is the stylesheet default, so it needs no attribute — keeping it off avoids a
    // redundant selector and makes the default obvious in devtools.
    if (theme === "blue") document.documentElement.removeAttribute("data-theme");
    else document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem(KEY, theme);
  }, [theme]);

  return (
    <div className="theme-picker">
      {THEMES.map((t) => (
        <button
          key={t.id}
          className={"swatch" + (t.id === theme ? " active" : "")}
          style={{ background: t.dot }}
          title={t.label}
          aria-label={`${t.label} theme`}
          aria-pressed={t.id === theme}
          onClick={() => setTheme(t.id)}
        />
      ))}
    </div>
  );
}
